<template>
  <div style="padding: 30px">
    <el-button @click="goBack">{{ $t("admin.back") }}</el-button>
    <el-button @click="home">{{ $t("login.login") }}</el-button>
    <div class="login" style="text-align: center; align-items: center">
      <div class="header">
        <br />
        <span>{{ $t("forgotpassword.resetyourpassword") }}</span>
        <h2 v-if="this.customer">{{ this.customer.name }}</h2>
        <h2 v-else><em class="el-icon-loading"></em></h2>
      </div>
      <el-card style="align-items: center; position: relative; margin: auto">
        <h2>{{ $t("forgotpassword.title") }}</h2>
        <el-form class="login-form" :model="form" :rules="rules" ref="form">
          <el-form-item prop="password">
            <el-input
              :disabled="!this.customer"
              v-model="form.password"
              :placeholder="$t('forgotpassword.password')"
              type="password"
              prefix-icon="fas fa-lock"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password2">
            <el-input
              :disabled="!this.customer"
              v-model="form.password2"
              :placeholder="$t('forgotpassword.password2')"
              type="password"
              prefix-icon="fas fa-lock"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin: 0px; padding: 0px; text-align:left">
            <p v-if="customer && customer.preferences && customer.preferences.passwordPolicy">
              <div class="validateerrors" style="padding-left:40px">
          <li v-if="customer.preferences.passwordPolicy.minCharacter">
          <span v-if="form.password.length<customer.preferences.passwordPolicy.minCharacter" style="color:red">{{"Min. Password Length "+customer.preferences.passwordPolicy.minCharacter}}</span>
          <span v-else style="color:green">{{"Min. Password Length "+customer.preferences.passwordPolicy.minCharacter}}</span>
         </li>
          <li v-if="customer.preferences.passwordPolicy.requiresLowerCaseLetters">
          <span v-if="!new RegExp(`[${this.lowerReg}]`).test(form.password)"  style="color:red">{{"Min. One LowerCase Character "}}</span>
           <span v-else style="color:green">{{"Min. One LowerCase Character "}}</span>
          </li>
           <li v-if="customer.preferences.passwordPolicy.requiresUpperCaseLetters">
          <span v-if="!new RegExp(`[${this.upperReg}]`).test(form.password)" style="color:red">{{"Min. One UpperCase Character "}}</span>
            <span v-else style="color:green">{{"Min. One UpperCase Character "}}</span>
           </li>
           <li v-if="customer.preferences.passwordPolicy.requiresSpecialCharacters">
           <span v-if="!new RegExp(`[${this.specialReg}]`).test(form.password)" style="color:red">{{"Min. One Special Character "}}</span>
            <span v-else style="color:green">{{"Min. One Special Character "}}</span>
           </li>
            <li v-if="customer.preferences.passwordPolicy.requiresNumbers">
           <span v-if="!new RegExp(`[${this.numberReg}]`).test(form.password)" style="color:red">{{"Min. One Numeric Character "}}</span>
            <span v-else style="color:green">{{"Min. One Numeric Character "}}</span>
            </li>
 </div>
            </p>
          </el-form-item>
          <el-form-item>
           
            <br />

            <el-button
              :disabled="!this.customer"
              class="login-button"
              type="primary"
              @click="submit()"
              block
              >{{ $t("forgotpassword.save") }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import passwordCheck from "../util/passwordCheck";

export default {
  name: "ForgotPassword",
  data() {
    var validatePass = (rule, value, callback) => {
      if (
        !passwordCheck.checkPassword(value, this.customer.preferences.passwordPolicy).result
      ) {
        callback(new Error(`Weak Password`));
        return;
      }
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== this.form.password || value != this.form.password2) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      upperReg:passwordCheck.upper,
      lowerReg:passwordCheck.lower,
      specialReg:passwordCheck.special,
      numberReg:passwordCheck.number,
      form: {
        password: "",
        password2: "",
      },
      rules: {
        password2: [{ validator: validatePass, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
      },
      timeout: 5,
    };
  },
  created() {
    this.loadCustomer();
  },
  computed: {
    ...mapState("account", ["status", "customer"]),
  },
  methods: {
    home() {
      window.location = "/login";
    },
    ...mapActions("account", ["logout","loadCustomer"]),
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (decodeURIComponent(pair[0]) == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      // console.log("Query variable %s not found", variable);
    },

    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var body = {
            password: this.form.password,
          };
          let token = this.getQueryVariable("token");
          if (!token) {
            let user = JSON.parse(localStorage.getItem("user"));
            if (user) {
              token = user.token;
            } else {
              window.location = "/";
            }
          }

          axios
            .post(`${process.env.VUE_APP_APIURL}/me/password`, body, {
              headers: {
                token: token,
              },
            })
            .then(() => {
              this.timeout = 5;
              let interval = setInterval(() => {
                this.timeout = this.timeout - 1;
                if (this.timeout == 0) {
                  clearInterval(interval);
                }
              }, 1000);
              this.$message.success(
                this.$t("forgotpassword.success_will_be_redirected")
              );
              setTimeout(() => {
                this.logout();
              }, this.timeout * 1000);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.el-dialog {
  margin-top: 15vh !important;
  width: 40% !important;
}
p {
  margin-left: 30px;
}
.el-form-item__content label.country-selector__label {
  line-height: normal;
}

.el-form-item__content label.input-tel__label {
  line-height: normal;
}
.vue-phone-number-input .select-country-container {
  min-width: 100px !important;
  max-width: 100px !important;
}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  margin-top: 30px;
  flex-basis: 80%;
  display: flex;
}
.component {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}
.component-container {
  margin: 0 10px 20px 10px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  min-width: 300px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  flex: 1 0 48%;
}
</style>